let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ej4rO"), load("5dGIX")]).then(() => parcelRequire('6IPlc'));